import { render, staticRenderFns } from "./collectorInquire.vue?vue&type=template&id=16e95b79&scoped=true"
import script from "./collectorInquire.vue?vue&type=script&lang=js"
export * from "./collectorInquire.vue?vue&type=script&lang=js"
import style0 from "./collectorInquire.vue?vue&type=style&index=0&id=16e95b79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e95b79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e95b79')) {
      api.createRecord('16e95b79', component.options)
    } else {
      api.reload('16e95b79', component.options)
    }
    module.hot.accept("./collectorInquire.vue?vue&type=template&id=16e95b79&scoped=true", function () {
      api.rerender('16e95b79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/collectorInquire.vue"
export default component.exports